import SelectedSheet from 'components/hoc/SelectedSheet';
import SheetTile from 'components/SheetTile';
import Fuse from 'fuse.js';
import React from 'react';
import { Sheet } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface DrawingsBrowserProps extends WithAppStoreProps {
  search?: string;
  className?: string;
}

interface SheetVersionSearch {
  sheetid: string;
  sheetnumber: string;
  sheettitle: string;
}

const searchOptions: Fuse.IFuseOptions<SheetVersionSearch> = {
  shouldSort: true,
  threshold: 0.2,
  keys: ['sheetnumber', 'sheettitle'],
};

const DrawingsBrowser: React.FC<DrawingsBrowserProps> = ({
  appStore,
  search,
  className,
}) => {
  const { state } = appStore;

  const getSearchedSheets = (): Sheet[] => {
    const { sheets } = state;

    const searchObjs = sheets
      .valueSeq()
      .map((s) => {
        const lastSheetVersion = s.versions.last<SheetVersion>();

        return {
          sheetid: s.sheetid,
          sheetnumber: lastSheetVersion.sheetnumber,
          sheettitle: lastSheetVersion.sheettitle,
        };
      })
      .toArray();

    const fuse = new Fuse(searchObjs, searchOptions);

    const searchedSheets: Sheet[] =
      search && search.length > 0
        ? fuse
            .search(search)
            .map(({ item }) => sheets.get(item.sheetid, new Sheet()))
        : [...sheets.values()];

    return searchedSheets;
  };

  const sheets = getSearchedSheets();

  const columns = 3;
  const rows = Math.ceil(sheets.length / 3);

  return (
    <div className={`b-2 oa bgd-light-grey-2 ${className}`}>
      <div
        className="m3"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 144px)`,
          gridTemplateRows: `repeat(${rows}, 144px)`,
          gridGap: '14px',
          justifyContent: 'space-evenly',
        }}
      >
        {sheets.map((s) => (
          <SelectedSheet key={s.sheetid} sheet={s}>
            {({ selected, handlePageSelectChange }) => (
              <SheetTile
                sheet={s}
                selected={selected}
                onSheetClick={handlePageSelectChange}
              />
            )}
          </SelectedSheet>
        ))}
      </div>
    </div>
  );
};

export default withAppStore<DrawingsBrowserProps>(DrawingsBrowser);
